module.exports = __webpack_public_path__ + "img/m-main-background.d17a78d3.png";